import { setOption as setThumbmarkjsOption, getFingerprint } from '@thumbmarkjs/thumbmarkjs';

const UPDATE_INTERVAL_MS = 300000;

const FINGERPRINT_PROMISE = Symbol('fingerprint-promise');

async function getNewFingerprint() {
  // set the exclude option
  setThumbmarkjsOption('exclude', ['screen', 'audio']);

  // Set the fingerprint header.
  return getFingerprint(false);
}

class Fingerprint {
  constructor() {
    if (!Fingerprint.instance) {
      Fingerprint.instance = this;

      this[FINGERPRINT_PROMISE] = getNewFingerprint();

      setInterval(async () => {
        this[FINGERPRINT_PROMISE] = getNewFingerprint();
      }, UPDATE_INTERVAL_MS);
    }

    return Fingerprint.instance;
  }

  async getFingerprint() {
    return this[FINGERPRINT_PROMISE];
  }
}

const instance = new Fingerprint();

export default instance;
